<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <ul id="creditsTabs" class="nav nav-tabs bar_tabs pull-right" role="tablist">
          <li role="presentation">
            <a href="#buyTab" data-toggle="tab">
              <i class="fas fa-hand-holding-usd"></i> Buy credits
            </a>
          </li>
          <li role="presentation" :class="{'bold loadedFileActive': loadedCreditStatus }">
            <a href="#detailTab" data-toggle="tab" @click="loadedCreditStatus = false">
              <i class="fas fa-info-circle"></i>
              Credit transaction details <span v-if="loadedCreditId != -1">{{ loadedCreditId }}</span>
            </a>
          </li>
          <li role="presentation">
            <a href="#overviewTab" data-toggle="tab" class="active">
              <i class="fas fa-table"></i> Overview
            </a>
          </li>
        </ul>
        <div id="ticketOverviewTabContent" class="tab-content">
          <div class="tab-pane" role="tabpanel" id="detailTab">
            <creditdetails
              :creditId="loadedCreditId"
              ref="creditEditor"
              :loadedCreditId.sync="loadedCreditId"
              :loadedCreditStatus.sync="loadedCreditStatus"
              v-on:creditSaved="reloadTable()"
            ></creditdetails>
          </div>
          <div class="tab-pane" role="tabpanel" id="buyTab">
            <buycredits></buycredits>
          </div>
          <div class="tab-pane active" role="tabpanel" id="overviewTab">
            <!--- Left panel with open files -->
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="card">
                <div class="card-content">
                  <v-server-table
                    :url="filterUrl"
                    :columns="columns"
                    ref="creditTable"
                    :options="options"
                  >
                    <template slot="type" slot-scope="props" style="text-align:center;">
                      <span v-if="props.row.type == 'added'" data-tooltip="Added">
                        <i class="fas fa-plus-square fa-3x"></i>
                      </span>
                      <span v-if="props.row.type == 'taken'" data-tooltip="Taken">
                        <i class="fas fa-minus-square fa-3x"></i>
                      </span>
                      <span v-if="props.row.type == 'rollback'" data-tooltip="Rolled back">
                        <i class="fas fa-undo fa-3x"></i>
                      </span>
                    </template>
                    <template
                      slot="customer"
                      slot-scope="props"
                    >{{ props.row.customer_first_name }} {{ props.row.customer_last_name }}</template>
                    <template slot="files" slot-scope="props">
                      <span v-if="props.row.files">
                        <span v-for="file in JSON.parse(props.row.files)">{{ file.name }}</span>
                      </span>
                      <span v-else>No files</span>
                    </template>
                    <template slot="comments" slot-scope="props">
                      <span v-if="props.row.comments">
                        <span v-for="comment in JSON.parse(props.row.comments)">
                          {{ comment.date }}: {{ comment.comment }}
                          <br>
                        </span>
                      </span>
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="tableAction">
                        <a
                          class="btn btn bg-blue"
                          @click="editRow(props.row.id)"
                          data-tooltip="View details"
                        >
                          <i class="fas fa-exchange-alt fa-lg"></i>
                        </a>
                      </div>
                    </template>
                  </v-server-table>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Creditdetails from "../../components/credit";
import Buycredits from "../../components/buycredit";
export default {
  components: {
    Creditdetails,
    Buycredits
  },
  data: function() {
    return {
      creditLoaded: "",
      loadingData: false,
      deleted_filter: false,
      date_start_filter: "",
      date_end_filter: "",
      loadedCreditStatus: false,
      loadedCreditId: -1,
      dataUrl: APIURL + "/credits",
      modalId: "prevModal",
      modalTitle: "modalTitle",
      modalBody: "modalBody",
      modalButtons: ["close"],
      options: {
        perPage: 10,
        headings: {
          created_at: "Date"
        }
      },
      filterUrl: APIURL + "/credits",
      columns: ["created_at", "type", "credits", "files", "actions"]
    };
  },
  methods: {
    reloadTable() {
      this.$refs.creditTable.customQueries[
        "show_deleted"
      ] = this.deleted_filter;
      this.$refs.creditTable.getData();

      $("html, body").animate({ scrollTop: 0 }, "fast");
      this.loadedCreditStatus = false;
      $('.nav-tabs a[href="#overviewTab"]').tab("show");
    },
    editRow(creditId) {
      this.loadedCreditStatus = true;
      var creditEditor = this.$refs.creditEditor;
      this.loadedCreditId = creditId;
      creditEditor.loadCreditDetails(creditId);
      $('.nav-tabs a[href="#detailTab"]').tab("show");
    }
  },
  computed: {
    ws: () => Webservice
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Credits/Overview.vue